import { render, staticRenderFns } from "./fourBody.vue?vue&type=template&id=cca4b9aa&scoped=true&"
import script from "./fourBody.vue?vue&type=script&lang=js&"
export * from "./fourBody.vue?vue&type=script&lang=js&"
import style0 from "./fourBody.vue?vue&type=style&index=0&id=cca4b9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca4b9aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca4b9aa')) {
      api.createRecord('cca4b9aa', component.options)
    } else {
      api.reload('cca4b9aa', component.options)
    }
    module.hot.accept("./fourBody.vue?vue&type=template&id=cca4b9aa&scoped=true&", function () {
      api.rerender('cca4b9aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/fourBody.vue"
export default component.exports